import React, { Component } from 'react';
import globals from "../globals";
import ProductDetails from "../modules/ProductDetails";
import RegisterBlock from "../modules/RegisterBlock";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import BasicList from "../modules/BasicList";

class SmallBusinessVoip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
			leadCopy: [],
            product: {
                details: {
                    leadCopy: [],
					secondItems: []
                },
                terms: [],
                features: []
            },
            seoTitle: '',
            seoDescription: '',
			dataReceived: false,
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/voip/small-business')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <ProductDetails product={this.state.product} bottomWave="bottom-wave-darkgreen">
                    <div className="row centered" style={{marginTop: '50px'}}>
                        <div className="col-xs-12">
                            <h3>Call features include:</h3>
							<BasicList list={this.state.product.features} />
                            <div className="inclusions">{this.state.product.inclusions}</div>
                        </div>
                    </div>
                </ProductDetails>
                <RegisterBlock />
            </div>
        );
    }

}

export default SmallBusinessVoip;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/SmallBusinessVoip.js